<template>
  <div class="app">
    <template v-if="!showNoAccess">
      <div class="bg-green" style="height:32px"></div>
      <div class="content">
        <div class="tab">
          <div @click="switchReport(true)" :class="dailyReport?'active':''">
            <img src="../assets/images/report-green.png" />
            <span>日报告</span>
          </div>
          <div @click="switchReport(false)" :class="dailyReport?'':'active'">
            <img src="../assets/images/report-red.png" />
            <span>周报告</span>
          </div>
        </div>
        <!-- <div class="banner">
          <img :src="bannerUrl" alt />
        </div>-->
        <div class="user-info">
          <template v-if="childInfo.length>1">
            <div class="select-watch">
              <div class="active-child" @click="selectWatch">
                <span>{{activeChildInfo.id?activeChildInfo.name : '未绑定'}}</span>
                <img src="../assets/images/arrow-down.png" />
                <div v-if="showSelect" class="watch-list">
                  <div
                    class="watch-list-item active"
                    @click.stop="selectChild(index)"
                    v-for="(item,index) in childInfo"
                    :key="index"
                  >{{item.name}}</div>
                </div>
              </div>
              <span>的成长报告</span>
            </div>
          </template>
        </div>
        <template v-if="dailyReport">
          <div v-for="(item,index) in reportList" :key="index">
            <div class="charts">
              <div class="title">{{item.appName}}应用题目数量图表</div>
              <div class="chart" :ref="'chart'+index"></div>
              <img src="../assets/images/achievement.png" class="achievement" />
              <div class="achieveList">
                <div>
                  <img src alt />
                  <p>
                    您的孩子已在该应用上累计学习了
                    <span>{{item.learnCount}}</span>道题目
                  </p>
                </div>
                <div>
                  <img src alt />
                  <p>
                    超过了
                    <span>{{item.passCount}}</span>位同龄小朋友
                  </p>
                </div>
                <div>
                  <img src alt />
                  <p>
                    目前排名为
                    <span>前{{item.rankPercent}}%</span>
                  </p>
                </div>
              </div>
              <!-- <div class="position-img">
                <img src="../assets/images/tip-integral.png" class="tip" />
                <img src="../assets/images/integral.png" class="buy-integral" />
              </div>-->
            </div>
          </div>
        </template>
        <template v-else>
          <div v-for="(item,index) in reportList" :key="index">
            <!-- <div class="banner">
              <img src="../assets/images/banner.png" alt />
            </div>-->
            <div class="charts">
              <div class="title">{{item.appName}}应用题目数量图表</div>
              <div class="chart" :ref="'chart'+index"></div>
              <img src="../assets/images/achievement.png" class="achievement" />
              <div class="achieveList">
                <div>
                  <img src alt />
                  <p>
                    您的孩子已在该应用上累计学习了
                    <span>{{item.learnCount}}</span>道题目
                  </p>
                </div>
                <div>
                  <img src alt />
                  <p>
                    超过了
                    <span>{{item.passCount}}</span>位同龄小朋友
                  </p>
                </div>
                <div>
                  <img src alt />
                  <p>
                    目前排名为
                    <span>前{{item.rankPercent}}%</span>
                  </p>
                </div>
              </div>
              <!-- <div class="position-img">
                <img src="../assets/images/tip-integral.png" class="tip" />
                <img src="../assets/images/integral.png" class="buy-integral"/>
              </div>-->
            </div>
          </div>
        </template>
      </div>
    </template>
    <NoAccess v-else></NoAccess>
  </div>
</template>

<script>
const echarts = require("echarts");
import { getDailyReport, getWeekReport } from "../api/api-report";
import { mapState } from "vuex";
import { Toast } from "vant";
import { apiUrl } from "../api/config";
import { listChildInfo } from "../api/api-child";
import NoAccess from "../components/NoAccess";
export default {
  data() {
    return {
      dailyReport: true,
      reportList: [],
      bannerUrl: apiUrl + "/min-program/v1/banner/banner?position=index",
      showSelect: false,
      activeChildIndex: 0,
      showNoAccess: false
    };
  },
  components: { NoAccess },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      childInfo: state => state.childInfo,
      activeChildInfo: state => state.activeChildInfo
    })
  },
  watch: {},
  methods: {
    getChildInfo() {
      // 获取openid
      if (window.WebViewJavascriptBridge) {
          console.log(22)
        var _this = this;
        xtc.getOpenId({
          appId: "100020",
          success: function(data) {
            // 成功回调
            console.log(data);
            //测试用数据
            let query = "?";
            let openId = data.openId;
            if (openId.length == 0) {
              _this.showNoAccess = true;
            } else {
              openId.forEach((element, index) => {
                if (index == openId.length - 1) {
                  query += "openIds=" + element;
                } else {
                  query += "openIds=" + element + "&";
                }
              });
              listChildInfo(query)
                .then(res => {
                  res.data.forEach((item, index) => {
                    if(item.name == '')item.name = "宝贝" + (index + 1);
                  });
                  console.log("chikdren：" + JSON.stringify(res));
                  if (res.code == 200) {
                    if (res.data.length > 0) {
                      _this.$store.dispatch("setChildInfo", res.data);
                      _this.$store.dispatch(
                        "setActiveChildInfo",
                        res.data[_this.activeChildIndex]
                      );
                    } else {
                      Toast.fail(res.msg);
                      _this.$store.dispatch("setChildInfo", []);
                      _this.$store.dispatch("setActiveChildInfo", {});
                    }
                  } else {
                    Toast.fail(res.msg);
                  }
                })
                .then(() => {
                  _this.getReportList();
                });
            }
          },
          fail: function(data, code) {
              console.log(56)
            // 失败回调
            let query = "?";
            let openId = ["e89e0a498afd41e2bd9d493a4182f5f2"]; //todo
            if (openId.length == 0) {
              _this.showNoAccess = true;
            } else {
              openId.forEach((element, index) => {
                if (index == openId.length - 1) {
                  query += "openIds=" + element;
                } else {
                  query += "openIds=" + element + "&";
                }
              });
              listChildInfo(query)
                .then(res => {
                  if (res.code == 200) {
                    if (res.data.length > 0) {
                      res.data.forEach((item, index) => {
                        item.name = "用户" + (index + 1);
                      });
                      _this.$store.dispatch("setChildInfo", res.data);
                      _this.$store.dispatch(
                        "setActiveChildInfo",
                        res.data[_this.activeChildIndex]
                      );
                    } else {
                      Toast.fail(res.msg);
                      _this.$store.dispatch("setChildInfo", []);
                      _this.$store.dispatch("setActiveChildInfo", {});
                    }
                  }
                })
                .then(() => {
                  _this.getReportList();
                });
            }
          }
        });
      } else {
          console.log(22)
        var _this = this;
          console.log(33)
        // 失败回调
        let query = "?";
        let openId = ["e89e0a498afd41e2bd9d493a4182f5f2"]; //todo
        if (openId.length == 0) {
          _this.showNoAccess = true;
        } else {
          openId.forEach((element, index) => {
            if (index == openId.length - 1) {
              query += "openIds=" + element;
            } else {
              query += "openIds=" + element + "&";
            }
          });
          listChildInfo(query)
            .then(res => {
              if (res.code == 200) {
                if (res.data.length > 0) {
                  res.data.forEach((item, index) => {
                    item.name = "用户" + (index + 1);
                  });
                  _this.$store.dispatch("setChildInfo", res.data);
                  _this.$store.dispatch(
                    "setActiveChildInfo",
                    res.data[_this.activeChildIndex]
                  );
                } else {
                  Toast.fail(res.msg);
                  _this.$store.dispatch("setChildInfo", []);
                  _this.$store.dispatch("setActiveChildInfo", {});
                }
              }
            })
            .then(() => {
              _this.getReportList();
            });
        }
      }
    },
    switchReport(bool) {
      this.dailyReport = bool;
      this.getReportList();
    },
    getReportList() {
      let params = {
        childId: this.activeChildInfo.id
      };
      if (this.dailyReport) {
        getDailyReport(params)
          .then(res => {
            if (res.code == 200) {
              this.reportList = res.data;
            } else {
              Toast.fail(res.msg);
            }
          })
          .then(() => {
            this.initCharts();
          });
      } else {
        getWeekReport(params)
          .then(res => {
            if (res.code == 200) {
              this.reportList = res.data;
            } else {
              Toast.fail(res.msg);
            }
          })
          .then(() => {
            this.initCharts();
          });
      }
    },
    initCharts() {
      this.reportList.forEach((item, index) => {
        let myChart = this.$echarts.init(this.$refs["chart" + index][0]); // 绘制图表
        let maxQues = 0,
          maxTime = 0,
          maxRight = 0;
        item.questionCount.forEach(it => {
          if (it > maxQues) {
            maxQues = it;
          }
        });
        item.playTimes.forEach(it => {
          if (it > maxTime) {
            maxTime = it;
          }
        });
        item.rightPercent.forEach(it => {
          if (it > maxRight) {
            maxRight = it;
          }
        });
        maxQues = Math.ceil((maxQues * 1.05) / 10);
        maxQues = maxQues * 10;
        maxQues = maxQues > 100 ? maxQues : 125;
        maxTime = Math.ceil((maxTime * 1.05) / 10);
        maxTime = maxTime * 10;
        maxRight = Math.ceil(maxRight / 10);
        maxRight = maxRight * 10;
        // let rightArr=[];
        // item.rightPercent.forEach(it=>{
        //   if(it==0){
        //     rightArr.push('')
        //   }else{
        //     rightArr.push(it)
        //   }
        // })
        // console.log(rightArr)
        myChart.setOption({
          legend: {
            data: [
              {
                name: "题目数",
                icon: "circle",
                textStyle: {
                  color: "#9B9B9B"
                }
              },
              {
                name: "正确率",
                icon: "circle",
                textStyle: {
                  color: "#9B9B9B"
                }
              },
              // {
              //   name: "时间",
              //   icon: "circle",
              //   textStyle: {
              //     color: "#9B9B9B"
              //   }
              // }
            ],
            top: 25
          },
          xAxis: {
            type: "category",
            data: item.axis,
            // name: "周",
            nameGap: 5,
            axisLabel: {
              rotate: -30,
              interval: 0,
              align: "center",
              verticalAlign: "top",
              padding: [15, 0, 0, 0],
              fontSize: 10
            },
            axisLine: {
              lineStyle: {
                color: "#BFBFBF"
              }
            },
            axisTick: {
              alignWithLabel: true
            },
            boundaryGap: true,
            nameTextStyle: {
              padding: [10, 0, 0, 0]
            }
          },
          //        grid: {
          //     right: '25%'
          // },
          yAxis: [
            {
              type: "value",
              name: "题目数(道)  ",
              nameTextStyle: {
                color: "#9B9B9B"
              },
              minInterval: 1,
              axisLine: {
                lineStyle: {
                  width: 0
                }
              },
              axisTick: {
                show: false
              },
              min: 0,
              max: maxQues,
              interval: Math.ceil(maxQues / 5),
              axisLabel: {
                formatter: "{value}"
              }
            },
            {
              type: "value",
              name: "    正确率(%)",
              nameTextStyle: {
                color: "#9B9B9B",
                ontStyle:'oblique',
              },
              position: 'right',
              // offset: 40,
              minInterval: 1,
              axisLine: {
                lineStyle: {
                  width: 0
                },
                show:false
              },
              axisTick: {
                show: false
              },

              min:0,
              // max:maxRight,
              // interval: Math.ceil(maxRight / 5),
              max:100,
              interval: 20,
              axisLabel: {
                  formatter: '{value}',
                  margin:12
              },
            },
            // {
            //   type: "value",
            //   name: "      时间(分)",
            //   nameTextStyle: {
            //     color: "#9B9B9B",
            //     ontStyle: "oblique"
            //   },
            //   // offset: 5,
            //   position: "right",
            //   minInterval: 1,
            //   axisLine: {
            //     lineStyle: {
            //       width: 0
            //     },
            //     show: false
            //   },
            //   axisTick: {
            //     show: false
            //   },

            //   min: 0,
            //   max: maxTime,
            //   interval: Math.ceil(maxTime / 5),
            //   axisLabel: {
            //     formatter: "{value}",
            //     margin: 0
            //   }
            // }
          ],
          color: ["#FFDE97", "#ABE4BA", "#FDBC88"],
          series: [
            // {
            //   data: item.questionCount,
            //   type: "bar",
            //   itemStyle: {
            //     normal: {
            //       color: "#FFDE97"
            //     }
            //   }
            // },
            {
              data: item.questionCount,
              type: "bar",
              name: "题目数",
              itemStyle: {
                normal: {}
              }
            },
            {
              data: item.rightPercent,
              type: "line",
              name: "正确率",
              lineStyle: {
                color: "#ABE4BA"
              },
              itemStyle: {
                borderWidth: 1,
                opacity: 0
              },
              // itemStyle: {
              //   normal: {
              //     label: {
              //       show: true,
              //        lineHeight: 0,
              //       formatter: params => {
              //         if (params.data == 0) {
              //           return "";
              //         } else {
              //           return params.data;
              //         }
              //       }
              //     }
              //   }
              // },
              yAxisIndex: 1
            },
            // {
            //   data: item.playTimes,
            //   type: "line",
            //   name: "时间",
            //   lineStyle: {
            //     color: "#FDBC88"
            //   },
            //   itemStyle: {
            //     borderWidth: 0,
            //     opacity: 0
            //   },
            //   yAxisIndex: 1
            // }
          ]
        });
      });
    },
    selectWatch() {
      this.showSelect = !this.showSelect;
    },
    selectChild(index) {
      this.$store.dispatch("setActiveChildInfo", this.childInfo[index]);
      this.activeChildIndex = index;
      this.showSelect = false;
      this.dailyReport = true;
      this.getReportList();
    }
  },
  created() {},
  mounted() {
    this.getChildInfo();
  }
};
</script>
<style scoped lang="less">
.app {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #ecf0f5;
  padding-bottom: 60px;

  .user-info {
    margin: 10px 0;
    .select-watch {
      margin-left: 20px;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      .active-child {
        width: 94px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 3px 6px 0px rgba(189, 199, 210, 0.4);
        border-radius: 14px;
        margin-right: 10px;
        line-height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        span {
          width: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
          height: 100%;
        }
      }
      img {
        width: 12px;
        height: 6px;
        margin-top: 3px;
      }
      .watch-list {
        position: absolute;
        width: 80px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 6px 0px rgba(215, 221, 227, 1);
        border-radius: 5px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        top: 30px;
        left: 0;
        padding: 0 5px;
        z-index: 20;
      }
    }
  }
  .content {
    padding: 0 14px;
    position: relative;
    top: -26px;
    .banner img {
      width: 100%;
    }
    .tab {
      display: flex;
      background: #fff;
      height: 52px;
      box-sizing: border-box;
      padding: 6px 0;
      border-radius: 26px;
      .active {
        color: #87e2cd;
      }
      & > div {
        display: flex;
        align-items: center;
        padding-left: 30px;
        width: 50%;
        img {
          margin-right: 15px;
        }
        &:first-child {
          border-right: 1px solid #e2e4e8;
        }
      }
    }
    .charts {
      background: #fff;
      box-shadow: 0px 3px 6px 0px rgba(189, 199, 210, 0.4);
      border-radius: 13px;
      text-align: center;
      padding-bottom: 20px;
      position: relative;
      .position-img {
        position: absolute;
        right: 0;
        .tip {
          position: absolute;
          top: -60px;
          right: 5px;
        }
      }
      .title {
        padding: 10px 0;
        text-align: center;
        font-size: 16px;
        color: #333;
        font-weight: bold;
        margin-bottom: -20px;
      }
      .chart {
        width: 100%;
        height: 220px;
      }
      & > .achievement {
        width: 233px;
        margin-top: -20px;
      }
      .achieveList {
        text-align: left;
        padding: 0 15px;
        font-size: 14px;
        color: #333;
        span {
          font-size: 26px;
          color: #87e2cd;
          font-weight: bold;
        }
      }
    }
  }
}
</style>